import Image from 'next/image';
import { prepareImagePath } from '../../../../services/lib/util';
import { Box } from '@mui/material';

export const PostHeroImage = ({ sourceUrl, title }) => (
  <div className="post-hero-image-wrapper">
    <Box sx={{ display: 'block', top: 0, bottom: 0, left: 0, right: 0 }}>
      <Image src={prepareImagePath(sourceUrl)} alt={title} title={title} fill />
    </Box>
  </div>
);
